import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-feedback-entry',
  templateUrl: './feedback-entry.component.html',
  styleUrls: ['./feedback-entry.component.scss']
})
export class FeedbackEntryComponent implements OnInit {

  constructor(private http: HttpClient) { }

  vm: IViewModel = {

  };

  addAnother() {
    this.vm = {};
    this.vm.errorText = undefined;
    this.vm.successText = undefined;
  }

  tryAgain() {
    this.vm.errorText = undefined;
    this.vm.successText = undefined;
  }

  submit() {
    if (!this.vm.userName) {
      this.vm.errorText = 'User Name Required';
      return;
    }
    if (!this.vm.resNumber) {
      this.vm.errorText = 'Res Number Required';
      return;
    }
    if (!this.vm.subject) {
      this.vm.errorText = 'Subject Required';
      return;
    }

    this.vm.workingText = "Submitting...";
    this.vm.addToTrackTable = false;
;
    const s = this.http.post(`${environment.scApiProtocol}://${environment.scApiHost}:${environment.scApiPort}/api/SantaCruz/SubmitFeedback`, this.vm).subscribe(
      (next: IResponse) => {
        console.log(next);
        next.success == true ? this.vm.successText = 'Thank You' : this.vm.errorText = next.message;
      },
      (err: any) => {
        console.log(err);
        this.vm.errorText = err.message || err;
        this.vm.workingText = undefined;
      },
      () => {
        s.unsubscribe();
        this.vm.workingText = undefined;
      });
  }

  ngOnInit() {
  }

}

interface IViewModel {
  userName?: string;
  resNumber?: string;
  subject?: string;
  body?: string;
  addToTrackTable?: boolean;
  
  successText?: string;
  errorText?: string;
  workingText?: string;
}

interface IResponse {
  success: boolean;
  message: string;
}